var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"icon-fade","mode":"out-in"}},[(_vm.imageSrc)?_c('img',{attrs:{"src":_vm.imageSrc}}):_c('Icon',{staticClass:"text-white fill-current opacity-50",attrs:{"name":"logo"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }